import { createContext } from "react";
import { WorkOrderApi } from "./work-order-api";

type ApiContextProps = {
  api?: WorkOrderApi,
  setToken: (token?: string) => void
}

const ApiContext = createContext<ApiContextProps>({
  api: undefined,
  setToken: () => { }
});
export default ApiContext;